import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { channelActions } from '../../../_actions';

import Superare from '../../../_assets/superare-logo.png';

import moment from 'moment';

class SuperareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain_uuid: JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
      submitting: false,
      domain: null, 
      welcome_title: null, 
      appToken: null,
      notificationsEnabled: false, 
      client_id: null, 
      chrome_app_id: null
    }

    this.closeModal = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'SUPERARE_NOTIFICATION') {
        this.setState({
          domain: element.domain, 
          welcome_title: element.welcome_title, 
          appToken: element.appToken,
          notificationsEnabled: element.notificationsEnabled, 
          client_id: element.client_id, 
          chrome_app_id: element.chrome_app_id,
          uuid: element.uuid
        })
      }
    });
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { dispatch, actionType } = this.props;
    
    this.setState({submitting: true});
    
    if ( !this.state.domain_uuid ) 
      return this.setState({submitting: false});

    let obj = {
      "channel": {
        "domain_uuid": this.state.domain_uuid,
        "channel_type": "SUPERARE_NOTIFICATION",
        "properties": {}
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      // If superare channel need edit function
      // obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(res => {
        if ( res.type !== constant ) {
          this.props.evt.handleSubmit();

          const data = res.data.data;

          self.setState({
            submitting: false, 
            domain: data.domain, 
            welcome_title: data.welcome_title, 
            appToken: data.appToken,
            notificationsEnabled: data.notificationsEnabled, 
            client_id: data.client_id, 
            chrome_app_id: data.chrome_app_id,
          });
  
          return toast.success(res.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });
  }

  render() {
    const state = this.state;
    const { submitting } = this.state;
    const { actionType } = this.props;

    let title;
    let subtitle;
    let button;
    let buttonLoading;

    switch (actionType) {
      // If superare channel need edit function
      // case 'edit':
      //   title = 'Editing Superare channel'
      //   subtitle = "You're enabling notifications via Superare Channel. Are you sure?"
      //   button = 'Edit'
      //   buttonLoading = 'Editing...'
      //   break;
      case 'view':
        title = 'Superare channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        break;
      default:
        title = 'Adding Superare channel'
        subtitle = "You're enabling notifications via Superare Channel. Are you sure?"
        button = 'Add'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={Superare} alt="Superare logo"/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                <i className="lnr lnr-cross"></i>
              </button>

              {
                actionType !== 'view' ?
                <form action="#" className="form clearfix" id="superareChannelForm" method="POST" onSubmit={this.handleSubmit}>
                    {
                      submitting ?
                        <button type="button" className="btn btn-blue float-right disabled" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="sr-only"> {buttonLoading}</span>
                        </button>    
                      : <button type="submit" className="btn btn-blue float-right">{button}</button>
                    }
                  </form>
                  : <SuperareCodeView />
              }
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class SuperareCodeView extends Component {
  render() {
    return (
      <div className="code-area clearfix">
        <p>Crie um arquivo chamado “sw.min.js” no diretório pai do seu site. Em seguida, cole o script abaixo dentro do arquivo “index.html” da sua página.</p>
        <pre>
          <code>
            {
              `importScripts("https://static-notification.argos4.me/fe/js/service-worker.js")`
            }
          </code>
        </pre>
        <button type="button" className="btn btn-blue float-right" data-dismiss="modal" aria-label="Close">OK</button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedSuperareModal = connect(mapStateToProps)(SuperareModal);
export { ConnectedSuperareModal as SuperareModal }